<template>
  <label
    :for="htmlFor"
    :class="['text-sm font-medium text-gray-900', disabled ? 'text-gray-400' : '', className] | twMerge"
  >
    <slot />
  </label>
</template>

<script>
export default {
  name: "FormLabel",
  props: {
    htmlFor: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    className: [String, Array]
  }
}
</script>
